import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const jadwaSelector = ({ jadwa }: ReducerState) => jadwa;
export const jadwaOrdersLoadingSelector = createSelector(
  jadwaSelector,
  ({ fetchOrdersStatus }) => fetchOrdersStatus === fetchStatuses.pending,
);
